import {
  GET_PRODUCT_LOCATIONS_DETAILS,
  GET_PRODUCT_LOCATIONS_DETAILS_LOADING
} from 'store/actions/app/product_assigned_locations.actions'

const initialState = {
  loading_product_locations_details: false,
  product_locations_details: {
    producto: null,
    almacenes: []
  }
}

const productAssignedLocationsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PRODUCT_LOCATIONS_DETAILS_LOADING:
      return {
        ...state,
        loading_product_locations_details: action.payload
      }
    case GET_PRODUCT_LOCATIONS_DETAILS:
      return {
        ...state,
        product_locations_details: action.payload
      }
    default:
      return state
  }
}

export default productAssignedLocationsReducer
